const ngModule = angular.module('bb.utils.page', []);

ngModule.factory('Page', ['$window', function($window: IWindowService): Page | Record<string, never> {
   return $window.Page || {};
}]);

export default ngModule;
